import { useQuery } from 'react-query';
import { getAllMaterials } from '../sp-firebase/materialsFB';
import { useMaterialsStore } from '../components/Stores/MaterialsStore';

export const useMaterials = () => {
  const { setIsMaterialsLoading, setMaterials } = useMaterialsStore();

  const fetchFunction = () => getAllMaterials();

  return useQuery('Material', fetchFunction, {
    onSuccess: (data) => {
      if (data) {
        setMaterials(data);
        setIsMaterialsLoading(false);
      }
    },
    onError: () => {
      setIsMaterialsLoading(false);
    },
    onSettled: () => {
      setIsMaterialsLoading(false);
    },
  });
};
